import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-cca5b742"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "window"
};
var _hoisted_2 = {
  class: "flex"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "返回", -1);
});

var _hoisted_4 = {
  class: "content_box"
};
var _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
var _hoisted_6 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_7 = {
  key: 0,
  class: "myrank"
};
var _hoisted_8 = {
  class: "left"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  key: 1,
  style: {
    "display": "inline-block",
    "width": "36px",
    "text-align": "center"
  }
};
var _hoisted_11 = {
  style: {
    "margin-left": "10px"
  }
};
var _hoisted_12 = {
  class: "org"
};
var _hoisted_13 = {
  key: 1,
  class: "myrank",
  style: {
    "padding-left": "150px"
  }
};
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  key: 1
};
var _hoisted_16 = {
  class: "left"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  key: 1,
  style: {
    "display": "inline-block",
    "width": "36px",
    "text-align": "center"
  }
};
var _hoisted_19 = {
  style: {
    "margin-left": "10px"
  }
};
var _hoisted_20 = {
  style: {
    "width": "200px"
  }
};
var _hoisted_21 = {
  style: {
    "width": "100px",
    "text-align": "right"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_Head = _resolveComponent("Head");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Head, {
    title: "在线学习",
    back: false
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: "back",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.back && _ctx.back.apply(_ctx, arguments);
        })
      }, [_hoisted_3, _createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_ArrowRight, {
            color: "#c62423"
          })];
        }),
        _: 1
      })])];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.dataList.flag ? 'tabbar tabcolor' : 'tabbar'),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.tabChange('0');
    })
  }, " 学分 ", 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.dataList.flag ? 'tabbar' : 'tabbar tabcolor'),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.tabChange('1');
    })
  }, " 学时 ", 2)]), _ctx.dataList.myListId != -1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_ctx.dataList.myListId == 1 || _ctx.dataList.myListId == 2 || _ctx.dataList.myListId == 3 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: _ctx.dataList.imgList[_ctx.dataList.myListId - 1],
    alt: ""
  }, null, 8, _hoisted_9)) : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.dataList.myListId), 1)), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.dataList.myList.userName), 1)]), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.dataList.myList.orgName), 1), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(_ctx.dataList.changeState == 'getperiodRank' ? _ctx.score(_ctx.dataList.myList.score) : _ctx.dataList.myList.time), 1), _createElementVNode("span", null, _toDisplayString(_ctx.dataList.changeState == 'getperiodRank' ? '学分' : '分钟'), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, " 暂无排名 "))]), _createElementVNode("div", null, [_ctx.dataList.listData.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 暂无数据 ~ ")) : (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList.listData, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "rank"
    }, [_createElementVNode("div", _hoisted_16, [index == 0 || index == 1 || index == 2 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: _ctx.dataList.imgList[index],
      alt: ""
    }, null, 8, _hoisted_17)) : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(index + 1), 1)), _createElementVNode("span", _hoisted_19, _toDisplayString(item.userName), 1)]), _createElementVNode("div", _hoisted_20, _toDisplayString(item.orgName), 1), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", null, _toDisplayString(_ctx.dataList.changeState == 'getperiodRank' ? _ctx.score(item.score) : item.time), 1), _createElementVNode("span", null, _toDisplayString(_ctx.dataList.changeState == 'getperiodRank' ? '学分' : '分钟'), 1)])]);
  }), 128))]))])])]);
}